module.exports = __webpack_public_path__ + "static/media/redirectGPTIcon.1bacc16c.svg";